import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9196776"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }

import { useAppStore } from '@/store/modules/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'Partners',
  props: {
    partners: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, {
    class: "partners__content",
    "full-width-mobile": ""
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (item, i) => {
        return (_openBlock(), _createElementBlock("div", { key: i }, [
          (_unref(useAppStore)().getBankLogo(item.id))
            ? (_openBlock(), _createBlock(_component_base_image, {
                key: 0,
                name: item.name,
                src: _unref(useAppStore)().getBankLogo(item.id),
                "border-radius": "",
                contain: "",
                height: "52",
                width: "140"
              }, null, 8, ["name", "src"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.name), 1))
        ]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})